module.exports = __webpack_public_path__ + "static/heller3-f90f83bc96f9c542fb6bbe1ff4abab75.jpg";